module.exports = __webpack_public_path__ + "static/img/2021.1297099.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2021.png
// module id = 3YBU
// module chunks = 1